import { getService } from "../../store/api";

const exportModel = (id) => async (dispatch, getState) => {
    const service = getService(getState());
    let data = null;
    let errors = {};
    try {
        const response = await service.fetchEndpoint(`v1/model/${id}/export`, 'GET');
        data = await response.json();
    } catch (response) {
        errors = await service.getErrors(response, 'model');
    }

    return { data, errors };
};

export default exportModel;
